<template lang="pug">
	div(v-if="ready")
		h2.step2-title(v-if="showTitle") {{title}}
		p.step2-copy {{paragraph}}

</template>

<style lang="stylus" scoped>
@import "../assets/css/general.styl"

h2
	font-size: 18px
	line-height: body-font-line-height-sm
p
	font-size: body-font-size
	line-height: body-font-line-height
</style>

<script>
import Vue from 'vue'

export default {
	props:{
		state: {
			type: Object,
			required: true
		},
		plan:{
			type: Object,
			required: true
		},
		showTitle:{
			type: Boolean,
			default: true
		}
	},
	data(){
		return {
			ready: false,
			title: "",
			paragraph: ""
		}
	},

	async created(){
		if(!this.plan){
			this.title = "Plans worth considering"
			this.paragraph = "Following are a few of the top performing and most popular 529 college savings plans."
			this.ready = true
			return
		}


		let enrollNow = this.plan.has_enroll_now

		let singleDeduction = Vue.filter('currency')(this.state.simple_tax_data.maximum_deduction_single,'$',0)
		let coupleDeduction = Vue.filter('currency')(this.state.simple_tax_data.maximum_deduction_couple,'$',0)

		this.ready = true

		if(this.state.simple_tax_data.has_parity){
			let singleParity, coupleParity
			singleParity = Vue.filter('currency')(this.state.simple_tax_data.maximum_deduction_single,'$',0)
			coupleParity = Vue.filter('currency')(this.state.simple_tax_data.maximum_deduction_couple,'$',0)

			if(enrollNow){
				this.title = `Your ${this.state.name} 529 plan options`
				this.paragraph = `Great news! As a resident of ${this.state.name} you can claim a state tax deduction on contributions of up to ${singleParity} a year (${coupleParity} for married couples filing jointly) to ${this.state.name} and non-${this.state.name} 529 plans. We found some top-rated plans in-state and out-of-state for you to consider. Remember, the best way to grow your college fund is to save early and often. Get started today!`
				return
			}

			this.title = `You have great options`
			this.paragraph = `Great news! As a resident of ${this.state.name} you can claim a state tax deduction on contributions of up to ${singleParity} a year (${coupleParity} for married couples filing jointly) to ${this.state.name} and non-${this.state.name} 529 plans. We found some top-rated plans in-state and out-of-state for you to consider. Remember, the best way to grow your college fund is to save early and often. Get started today!`
			return
		}

		if(this.state.simple_tax_data.has_credit){
			let singleCredit, coupleCredit, creditPercentage
			singleCredit = Vue.filter('currency')(this.state.simple_tax_data.maximum_credit_single,'$',0)
			coupleCredit = Vue.filter('currency')(this.state.simple_tax_data.maximum_credit_couple,'$',0)
			creditPercentage = this.state.simple_tax_data.credit_rate_for_deduction * 100

			if(enrollNow){
				this.title = `Your ${this.state.name} 529 plan options`
				this.paragraph = `Great news! As a resident of ${this.state.name} you can claim a state tax credit of ${creditPercentage}% on contributions of up to ${singleCredit} a year (${coupleCredit} for married couples filing jointly) to ${this.plan.name}. Remember, the best way to grow your college fund is to save early and often. Get started today!`
				return
			}

			this.title = `You have great options`
			this.paragraph = `Good news. As a resident of ${this.state.name} you can claim a state tax credit of ${creditPercentage}% on contributions of up to ${singleCredit} a year (${coupleCredit} for married couples filing jointly) to your state's plan. You're not limited to investing in your state's plan. We found some top-rated plans with high performance and low fees for you to consider along with your state's plan. Remember, the best way to grow your college fund is to save early and often. Get started today!`
			return
		}

		if(this.state.simple_tax_data.has_deduction){
			if(enrollNow){
				this.title = `Your ${this.state.name} 529 plan options`
				if(this.state.simple_tax_data.has_unlimited_deductible_contributions){
					this.paragraph = `Great news! As a resident of  ${this.state.name} you can claim a state tax deduction on all contributions to ${this.plan.name}. Remember, the best way to grow your college fund is to save early and often. Get started today.`
					return
				}

				this.paragraph = `Great news! As a resident of  ${this.state.name} you can claim a state tax deduction on contributions of up to ${singleDeduction} a year (${coupleDeduction} for married couples filing jointly) to ${this.plan.name}. Remember, the best way to grow your college fund is to save early and often. Get started today.`
				return
			}

			this.title = `You have great options`
			if(this.state.simple_tax_data.has_unlimited_deductible_contributions){
				this.paragraph = `Good news. As a resident of ${this.state.name} you can claim a state tax deduction on all contributions to your state's plan. You're not limited to investing in your state's plan. We found some top-rated plans with high performance and low fees for you to consider along with your state's plan. Remember, the best way to grow your college fund is to save early and often. Get started today!`
				return
			}

			this.paragraph = `Good news. As a resident of ${this.state.name} you can claim a state tax deduction on contributions of up to ${singleDeduction} a year (${coupleDeduction} for married couples filing jointly) to your state's plan. You're not limited to investing in your state's plan. We found some top-rated plans with high performance and low fees for you to consider along with your state's plan. Remember, the best way to grow your college fund is to save early and often. Get started today!`
			return
		}

		// No deduction, no credit, no parity
		if(enrollNow){
			this.title = `You have great options`
			this.paragraph = `Good news. ${this.state.name} offers the ${this.plan.name} to save for college and take advantage of tax-free growth and withdrawals. We also found some top-rated 529 plans with high performance and low fees for you to consider along with your state's plan. Remember, the best way to grow your college fund is to save early and often. Get started today!`
			return
		}

		this.title = `You have great options`
		this.paragraph = `${this.state.name} does not offer residents a state tax deduction for 529 plan contributions, so shop around. We found some top-rated 529 plans with high performance and low fees for you to consider along with your state's plan. All of these plans let you take advantage of the tax-free growth and withdrawals that come with a 529 plan. Remember, the best way to grow your college fund is to save early and often. Get started today!`
		return
	},
}
</script>
